<script setup>
import Sidebar from "@/components/layout/Sidebar.vue";
import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
import { RouterView } from "vue-router";
</script>

<template>
  <div class="page-layout">
    <RouterView />
  </div>
</template>
